var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner__image"},[_c('img',{attrs:{"src":_vm.assets.spinnerGrey}})])])}
var staticRenderFns = []

export { render, staticRenderFns }